export default "__VITE_ASSET__d0efa5f9__"